import { CORS_MODE_NAME, FetchRequestOptions, fetchService } from 'owa-data-provider-info-fetcher';
import { logNoBPOSForDriveId } from 'owa-fluid-datapoints';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { lazyGetBposNavBarDataHelper } from 'owa-fluid-tenantconfig';
import type NavBarData from 'owa-service/lib/contract/NavBarData';

const GRAPH_SPECIAL_FOLDER_BY_NAME = 'https://graph.microsoft.com/v1.0/me/drive/special/';
const FUNCTION_NAME = 'getSpecialFolderInfo';

export async function getSpecialFolderInfo(folderName: string): Promise<string | undefined> {
    let folderInfo: string;

    if (!folderName) {
        throw new Error('No folderName was received.');
    }

    const requestOptions: FetchRequestOptions = {
        method: 'GET',
        mode: CORS_MODE_NAME,
        body: undefined,
        datapointNamePrefix: FUNCTION_NAME,
    };

    let requestUrl = '';

    const bposNavBarData: NavBarData | null = await lazyGetBposNavBarDataHelper.importAndExecute(
        FUNCTION_NAME
    );
    if (!bposNavBarData) {
        // We fallback to Graph API in case bposNavBarData is not available
        requestUrl = GRAPH_SPECIAL_FOLDER_BY_NAME;
        logNoBPOSForDriveId(FUNCTION_NAME);
    } else {
        requestUrl = bposNavBarData.SPO_MySiteHostUrl + '_api/v2.0/me/drive/special/';
    }

    requestUrl += folderName;

    const responseText = await fetchService(
        AttachmentDataProviderType.OneDrivePro,
        requestUrl,
        requestUrl,
        requestOptions,
        null // additionalHeaders
    );

    if (responseText) {
        folderInfo = JSON.parse(responseText).name;
    } else {
        const isBposRequestStr = !bposNavBarData ? 'NoBposNavBarData - ' : '';
        throw new Error(FUNCTION_NAME + ' - ' + isBposRequestStr + 'No response was received');
    }

    return folderInfo;
}
